import { ItemCard } from "./ItemCard";

export type ItemBranch = { id: number; components: ItemBranch[] };

export function getItemBranch(rootBranch: ItemBranch, branchPath: number[]) {
  if (branchPath.length === 0) {
    return null;
  }

  let currentBranch: ItemBranch = rootBranch;
  for (let i = 0; i < branchPath.length; i++) {
    currentBranch = currentBranch.components[branchPath[i]];
  }
  return currentBranch;
}

export function getTotalComponents(branch: ItemBranch) {
  let itemCount = branch.components.length;

  for (let component of branch.components) {
    itemCount += getTotalComponents(component);
  }

  return itemCount;
}

interface RecipeBranchProps {
  index: number;
  itemId: number;
  branchPath: number[];
  rootBranch: ItemBranch;
}

export function RecipeBranch(props: RecipeBranchProps) {
  const { itemId, index, branchPath, rootBranch } = props;
  const depth = branchPath.length;

  const currentBranch = getItemBranch(rootBranch, branchPath);

  const calculateBranchType = (depth: number, rootBranch: ItemBranch, index: number) => {
    let itemCount = 0;

    if (index === 0) {
      return `branch-${depth}-${itemCount}`;
    }

    const previousBranchPath = [...branchPath];
    previousBranchPath[depth - 1] = previousBranchPath[depth - 1] - 1;
    const previousBranch = getItemBranch(rootBranch, previousBranchPath);

    itemCount = previousBranch ? getTotalComponents(previousBranch) + 1 : 1;

    return `branch-${depth}-${itemCount}`;
  };

  if (!currentBranch) return null;

  return (
    <div className="branch-container">
      <div className="branch-main">
        <div className={calculateBranchType(depth, rootBranch, index)}></div>
        <div>
          <ItemCard itemId={itemId} />
          {currentBranch?.components.map(({ id, components }, i) => (
            <RecipeBranch
              key={`${id}-${i}-${depth}`}
              itemId={id}
              index={i}
              branchPath={[...branchPath, i]}
              rootBranch={rootBranch}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
